// extracted by mini-css-extract-plugin
export default {"name":"assembly-catalog-table_name__D1t4r","symbol":"assembly-catalog-table_symbol__n5nc0","actions":"assembly-catalog-table_actions__H+IKZ"};